/* eslint-ignore */
// @ts-nocheck
import React, { Component, useMemo } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import {
  Container,
  Header,
  Left,
  Title,
  CloseIcon,
  Content,
  InfoContainer,
  Info,
  InfoTitle,
  InfoText,
  Hr,
  StatusIcon,
  DetailsContainer,
  SectionTitle,
  DetailsContent,
} from './styles';

function OSModal({ close, serviceOrder }) {
  const labelStatus = useMemo(() => {
    const statusCode = serviceOrder?.statusCode ?? 'DEFAULT';
    switch (statusCode) {
      case 'AGPLAN':
      case 'AAPRV':
      case 'APROG':
        return 'OS em análise';
      case 'APROVADO':
      case 'EMAND':
      case 'PAUSADA':
      case 'AGADEQ':
      case 'AGMAT':
      case 'ADIADO':
        return 'OS de atendimento';
      case 'COMP':
      case 'FECHAR':
      case 'CONFERIDO':
        return 'OS finalizada';
      case 'CANCEL':
      case 'SEMEXEC':
        return 'OS cancelada';
      default:
        return 'OS em análise';
    }
  }, [serviceOrder]);

  const colorStatus = useMemo(() => {
    const statusCode = serviceOrder?.statusCode ?? 'DEFAULT';
    switch (statusCode) {
      case 'AGPLAN':
      case 'AAPRV':
      case 'APROVADO':
      case 'EMAND':
      case 'PAUSADA':
      case 'APROG':
      case 'AGADEQ':
      case 'AGMAT':
      case 'ADIADO':
        return '#f0b01b';
      case 'COMP':
      case 'FECHAR':
      case 'CONFERIDO':
        return '#75B943';
      case 'CANCEL':
      case 'SEMEXEC':
        return '#e32a2a';
      default:
        return '#f0b01b';
    }
  }, [serviceOrder]);

  return (
    <Container>
      <Header>
        <Left>
          <Title>Ordem de serviço</Title>
        </Left>
        <CloseIcon title="Fechar" className="mdi mdi-close" onClick={close} />
      </Header>

      <Content>
        <InfoContainer>
          <div
            className="d-flex flex-row align-items-center justify-content-between"
            style={{ flexWrap: 'wrap' }}
          >
            <Info>
              <InfoTitle>Número da OS:</InfoTitle>
              <InfoText>
                {serviceOrder.nameOs
                  ? serviceOrder.nameOs
                  : serviceOrder.numberOs
                  ? Number(serviceOrder.numberOs)
                      .toString()
                      .replace('.', '')
                      .replace(/0+$/gm, '')
                  : null}
              </InfoText>
            </Info>
            <Info className="mt-2">
              <InfoTitle>Prestador equipe técnica:</InfoTitle>
              <InfoText>
                {serviceOrder.team ? serviceOrder.team : null}
              </InfoText>
            </Info>
            <Info>
              <InfoTitle>Status:</InfoTitle>
              <div className="d-flex flex-row align-items-center justify-content-between">
                <StatusIcon color={colorStatus} />
                <InfoText>{labelStatus}</InfoText>
              </div>
            </Info>
          </div>
        </InfoContainer>
        <Hr />
        <DetailsContainer>
          <SectionTitle>Detalhes</SectionTitle>
          <DetailsContent>
            {serviceOrder.responsibleAttendance ? (
              <Info className="mt-2">
                <InfoTitle>Nome do técnico:</InfoTitle>
                <InfoText>
                  {serviceOrder.responsibleAttendance
                    ? serviceOrder.responsibleAttendance
                    : null}
                </InfoText>
              </Info>
            ) : null}
            {serviceOrder.attendanceForecastDate ? (
              <Info className="mt-2">
                <InfoTitle>Data prevista de atendimento:</InfoTitle>
                <InfoText>
                  {moment(serviceOrder.attendanceForecastDate).format(
                    'DD/MM/YYYY - HH:mm'
                  )}
                </InfoText>
              </Info>
            ) : null}
          </DetailsContent>
        </DetailsContainer>
      </Content>
    </Container>
  );
}

export default OSModal;
